import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from './loader.service';
import { LoaderState } from '../globalConfig';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

	public show = false;
	private subscription: Subscription;

	constructor(private loaderService: LoaderService) { }

	ngOnInit() {
		this.subscription = this.loaderService.loaderState
    .subscribe((state: LoaderState) => {
        if(state.multiCall && !state.show){

        }else{
          this.show = state.show;
        }
    });
	}
	ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/loader/loader.component.ts